const FinishedIcon = ({
  color = "#F4BC4D",
  background = "#648C94",
  size = 20,
  noBackground = false,
}) => (
  <svg
    width={`${size}`}
    height={`${size}`}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {noBackground === true ? null : (
      <rect width="20" height="20" rx="10" fill={background} />
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.04046 5.00004C6.01377 4.67343 5.99995 4.33954 5.99995 4H14C14 4.33948 13.9861 4.67331 13.9595 4.99988L15 4.99983C15 4.99983 15 5 15.5 5L16 5.00022L16 5.00124L15.9999 5.0034L15.9999 5.01041L15.9997 5.0349C15.9994 5.05576 15.9989 5.08554 15.9978 5.12326C15.9957 5.19865 15.9916 5.30603 15.9834 5.43744C15.967 5.69951 15.9342 6.06098 15.8681 6.4572C15.7418 7.21512 15.4743 8.23279 14.8535 8.85355C14.2303 9.47678 13.2129 9.7444 12.4549 9.87019C12.3462 9.88823 12.2402 9.90374 12.1381 9.9171C11.6847 10.4199 11.1695 10.7675 10.617 10.9172C10.5281 11.2096 10.4675 11.5278 10.5 11.8C10.5617 12.3187 11 13 11 13C11.5522 13 12 13.4477 12 14H13V16H14V17H5.99995V16H6.99995V14H7.99995C7.99995 13.4477 8.44767 13 8.99995 13C8.99995 13 9.43821 12.3187 9.49995 11.8C9.53236 11.5278 9.47184 11.2096 9.3829 10.9172C8.83045 10.7675 8.31535 10.42 7.86199 9.91728C7.75987 9.90392 7.65379 9.8884 7.54509 9.87036C6.78703 9.74456 5.76967 9.47695 5.14645 8.85372C4.52569 8.23296 4.25812 7.21529 4.1318 6.45737C4.06577 6.06115 4.03298 5.69968 4.0166 5.43761C4.00839 5.30619 4.00424 5.19882 4.00215 5.12343C4.0011 5.08571 4.00056 5.05592 4.00029 5.03507L4.00004 5.01057L4.00001 5.00357L4 5.00141V5.00039L4.5 5.00017C5 5.00017 5 5 5 5L6.04046 5.00004ZM6.16563 6.00017H5.07478C5.08712 6.09462 5.10148 6.19268 5.1182 6.29297C5.24188 7.03505 5.47431 7.76737 5.85355 8.14661C6.12181 8.41487 6.56307 8.60936 7.0586 8.74395C6.65095 7.97029 6.3417 7.03541 6.16563 6.00017ZM12.9414 8.74376C13.349 7.9701 13.6583 7.03523 13.8343 6H14.9252C14.9128 6.09445 14.8985 6.19251 14.8818 6.2928C14.7581 7.03488 14.5256 7.7672 14.1464 8.14645C13.8781 8.4147 13.4369 8.60917 12.9414 8.74376Z"
      fill={color}
    />
  </svg>
);

export default FinishedIcon;
